
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 56 68","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M0 30h32v8H0z"}}),_c('path',{staticClass:"st0",attrs:{"transform":"rotate(45.001 39.03 16.97)","d":"M19 13h40v8H19z"}}),_c('path',{staticClass:"st0",attrs:{"transform":"rotate(-45.001 39.03 51.03)","d":"M19 47h40v8H19z"}})])
          )
        }
      }
    